module.exports = __webpack_public_path__ + "media/forum/share-forum-post-logo-5075ffba.png";